export default {
  ADYEN: 'ADYEN',
  WORLDPAY: 'WORLDPAY',
  CHECKOUT_COM: 'CHECKOUT_COM',
  CHASE: 'CHASE',
  NUVEI: 'NUVEI',
};
